import React from "react"
import { AppAffectedList, AppValueChip } from "@components"
import useReportMultipleModalMultipleEdit from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions/useEditMultiple"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { validateFormat } from "@utils"
import { TagFieldSeeker } from "@ui-seeker/core"


export default function ReportMultiModalEmailSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()

	return <>
		<TagFieldSeeker
			onChange={e => {
				if (e.every(e => validateFormat('email', e))) setData(e)
			}}
			value={data}
			label="Emails"
			placeholder="Press Enter for each email"
		/>
		<ReportMultiModalEmailsDetails/>
	</>
}


function ReportMultiModalEmailsDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <AppAffectedList
		hint="current emails"
		rows={reportsInfo.value.map(({ name, notificationEmail }, idx) => ({
			key: `${name}-${idx}`,
			name,
			content: notificationEmail?.length
				? notificationEmail.map((value, emailIdx) => <AppValueChip key={`${value}-${emailIdx}`}>{value}</AppValueChip>)
				: <AppValueChip tone="empty">No emails</AppValueChip>,
		}))}
	/>
}
